import { useEffect, useState } from "react"
import Recipes, { IRecipe } from "../../shared/Recipes"
import EmptyRecipe from "./EmptyRecipe"
import Loading from "../../libs/loading/Loading"
import RecipeCache from "../../data/RecipeCache"
import Usernames from "../../libs/login/Usernames"
import Utils from "../../libs/Utils"
import useViewRecipe from "./RecipeDlg"
import Table from "../../gui/Table/Table"
import { usePath } from "../../libs/path/PathProvider"

const LABELS : Record<string,string> = {
    name:"Recipe",
    user:"Author",
    created:"Published"
}
function _username(props:{userId:string}) {
    const [name,setName] = useState<string>("")
    useEffect(() => {
        Usernames.i.get(props.userId).then(name => setName(name))
    },[props.userId])
    return <div>{name ? name : <Loading/>}</div>
}

function _list(props:{recipes:IRecipe[]}){
    const list = props.recipes
    const {viewRecipe,hideRecipe} = useViewRecipe()
    const {path,setPath} = usePath()

    const cell = (row:IRecipe, col:string) => {
        switch(col){
        case "name":      return <div className="name"><div className="w700">{row.name}</div><div className="small-text">{row.description}</div></div>
        case "user":      return <_username userId={row.user}/>
        case "created":   return <div className="date">{Utils.formatDate("yyyy-MM-dd", new Date(row.created))}</div>
        default:          return ""
        }
    }
    const onRecipe = (row:IRecipe) => () => setPath(`/home/${row._id}`)
    const rowProp = (row:IRecipe) => ({onClick:onRecipe(row)})

    useEffect(() => {
        const [_,home,recipeId] = path.split("/")
        if (recipeId) viewRecipe(list.find(r => r._id==recipeId))    
        else hideRecipe()
    }, [path])

    return <div className="recipeList">
        <Table tableName="recipies" rows={list} cols={["name","user","created"]} label={LABELS} rowKey={row => row._id} cellText={cell} tr={rowProp} htr={{className:"sticky"}}/>
    </div>
}
export default function RecipeList(){
    const [recipes,setRecipes] = useState<IRecipe[]|null>(null)
    const onUpdate = (_:string,recipes:Recipes) => setRecipes([...recipes.items])
    useEffect(() => {
        RecipeCache.i.getRecipes().then(recipes => setRecipes([...recipes.items]))
        RecipeCache.i.on("update", onUpdate)
        return () => {RecipeCache.i.removeListener("update", onUpdate)}
    },[])
    const list = recipes ? (recipes.length==0 ? <EmptyRecipe/> : <_list recipes={recipes}/>) : <Loading className="mt-32"/>
    return <div id="recipes">
        {list}
    </div>
}